import { Component, Renderer2, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { LoadingService } from './services/loading.service';

import { Footer } from './components/footer/footer';
import { HeaderComponent } from './components/header/header.component';
import { CookieConsentComponent } from './components/cookie-consent/cookie-consent.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, Footer, HeaderComponent, CookieConsentComponent, MatProgressSpinnerModule],
})
export class App {
  private renderer = inject(Renderer2);
  private loadingService = inject(LoadingService);

  isLoading = this.loadingService.loading;
  errorSend = this.loadingService.errorSend;

  toggleMegaMenuEquipments(): void {
    if (typeof document !== 'undefined') {
      const mainMenu = document.getElementById('mainMenu');
      const dropdown = document.getElementById('megaMenuEquipos');
      const megaMenuEquipments = document.getElementById('megaMenuEquipments');

      if (!mainMenu || !dropdown || !megaMenuEquipments) {
        return;
      }
      const isOpen = dropdown.classList.contains('open');

      if (isOpen) {
        this.renderer.removeClass(mainMenu, 'blurred');
        this.renderer.removeClass(dropdown, 'open');
        this.renderer.removeClass(megaMenuEquipments, 'open');
      } else {
        this.renderer.addClass(mainMenu, 'blurred');
        this.renderer.addClass(dropdown, 'open');
        this.renderer.addClass(megaMenuEquipments, 'open');
      }
    }
  }
}
